import React, { } from "react";
import { Pressable, Text, View, Image } from "react-native";
import { View as AnimatableView } from "react-native-animatable";

import { getCommonDateTime } from "../services/DateTimeUtils";
import { extendSnackBarData } from "../services/ExtendedDataUtils";
import { getImagePath, isChemistStoreLoaded } from "../services/CommonUtils";

import { RightArrowIcon } from "./Common-Widget";
import { ScreenRoute } from "../constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../constants/AppColors";

import PaginationItem from "./Carousel/Pagination";
import CustomCarousel from "./Carousel/CustomCarousel";

const OrderSnackBarView = (orderList, index, scallingFactor, viewWidth, viewHeight, callback) => {
    var orderData = extendSnackBarData(orderList[index])
    let textColor = Colors.black, iconColor = Colors.black
    let chemistStoreLoaded = isChemistStoreLoaded()
    if (chemistStoreLoaded) {
        textColor = Colors.white
        iconColor = Colors.white
    }

    return (<Pressable onPress={() => { callback(orderData, index) }}
        style={[AppStyles.flexRowStart, {
            paddingHorizontal: 16, paddingTop: 12, paddingBottom: 16,
        }]}>
        <Image style={{ width: 32, height: 32 }}
            source={{ uri: getImagePath(orderData['statusIcon']) }} />
        <View style={{
            marginLeft: 12, marginRight: 24,
            width: AppTheme.appWidth - 120
        }}>
            <Text style={[TextStyle.text14b, { color: textColor }]}
                numberOfLines={1}>{orderData['title']}</Text>
            <Text style={[TextStyle.text12, {
                color: textColor, marginTop: 4
            }]} numberOfLines={1}>{orderData['description'] ?
                orderData['description'] : getCommonDateTime(orderData['ts'])}</Text>
        </View>
        <RightArrowIcon tintColor={iconColor} />
    </Pressable>
    )
}

const SnackBarPaginationView = (carouselData, progressValue) => {
    return (<View style={[AppStyles.flexRowCenter, {
        width: AppTheme.appWidth,
        position: "absolute", bottom: 4
    }]}>{carouselData.map((data, index) => {
        return (<PaginationItem key={index} index={index}
            width={8} height={2}
            animValue={progressValue} length={carouselData.length}
            viewStyle={{ backgroundColor: Colors.grey.bg }}
            highlightedViewStyle={{ backgroundColor: Colors.primary }} />
        );
    })}</View>)
}

export const BottomSnackBarView = (props) => {
    const orderList = props.orderList
    let backgroundColor = AppTheme.color.orange.bg
    let chemistStoreLoaded = isChemistStoreLoaded()
    if (chemistStoreLoaded) backgroundColor = Colors.grey.opaque

    function handleSnackBarNavigation(orderData, index) {
        if (orderData['isActiveOrder']) {
            props.navigation.navigate(ScreenRoute.orders, {
                scrollOrderListToIndex: {
                    isActiveOrder: orderData['isActiveOrder'],
                    index: index
                }
            })
        } else props.navigation.navigate(
            ScreenRoute.view_order_summary, { orderData: orderData })
    }

    return (
        <AnimatableView key={'Order Snack Bar View'}
            style={[AppStyles.bottomFix, {
                marginBottom: AppTheme.bottomNavBarHeight,
                backgroundColor: backgroundColor
            }]} animation="slideInUp" duration={AppTheme.transitionDuration * 2}>
            <CustomCarousel carouselData={orderList}
                carouselViewBuilder={OrderSnackBarView}
                paginationViewBuilder={SnackBarPaginationView}
                autoPlay={false}
                viewWidth={AppTheme.appWidth} viewHeight={64}
                scallingFactorOffset={AppTheme.appWidth}
                autoPlayInterval={AppTheme.carouselTransitionDuration}
                callback={handleSnackBarNavigation} />
        </AnimatableView>
    )
}